import { useState} from "react";
import { MeetingProvider } from "@videosdk.live/react-sdk";
import MeetingView from "../VideoSDK/MeetingView";
import JoinScreen from "../VideoSDK/JoinScreen";
import { authToken, createMeeting } from "../VideoSDK/Api";


const MeetingPage = () => {
  const [meetingId, setMeetingId] = useState("");
  const fullName = sessionStorage.getItem("fullName");
  const loanID = sessionStorage.getItem("LoanID");
  const formattedUserName = sessionStorage.getItem("formattedUserName");

  const getMeetingAndToken = async (id) => {
    const newMeetingId = id == null ? await createMeeting({ token: authToken, loanID }) : id;
    setMeetingId(newMeetingId);
    return newMeetingId;
  };

  const onMeetingLeave = () => {
    sessionStorage.removeItem("LoanID");
    sessionStorage.removeItem("fullName");
    sessionStorage.removeItem("formattedUserName");
    window.close();
  };

  const meetingUrl = meetingId
    ? `${window.location.origin}/vpd?meetingId=${meetingId}&name=${fullName}&Username=${formattedUserName}&loanId=${loanID}`
    : null;

  return (
    <div>
      {loanID && authToken && meetingId ? (
        <MeetingProvider
          config={{
            meetingId,
            micEnabled: true,
            webcamEnabled: true,
            name: fullName,
            maxResolution: "hd",
          }}
          token={authToken}
        >
          <MeetingView
            meetingId={meetingId}
            onMeetingLeave={onMeetingLeave}
            loanID={loanID}
          />
        </MeetingProvider>
      ) : (
        <JoinScreen
          getMeetingAndToken={getMeetingAndToken}
          meetingUrl={meetingUrl}
          loanID={loanID}
        />
      )}
    </div>
  );
};

export default MeetingPage;